export default "__VITE_ASSET__DM72GecK__"